export class FormationSingle {
  constructor() {
    this.root = document.querySelector('[data-formation-single]')
    if (!this.root) return

    this.header = document.querySelector('.h-wrap')
    this.nav = this.root.querySelector('[data-formation-anchornav]')
    this.toggle = this.root.querySelector('[data-formation-nav-toggle]')
    this.mobile = this.root.querySelector('[data-formation-nav-mobile]')
    this.sections = this.root.querySelectorAll('[data-formation-section]')
    this.deskLinks = this.root.querySelectorAll('.s-formation__anchornav-links a')
    this.mobLinks = this.root.querySelectorAll('[data-formation-nav-mobile] a[href^="#"]')
    this.applyModal = this.root.querySelector('[data-formation-apply-modal]')
    this.noticeModal = this.root.querySelector('[data-formation-notice-modal]')

    this.syncNavOffset()
    window.addEventListener('resize', this.syncNavOffset)

    this.bindMobileNav()
    this.bindActiveSection()
    this.bindApplyModal()
    this.bindNoticeModal()
  }

  syncNavOffset = () => {
    if (!this.nav) return
    const top = this.header ? this.header.offsetHeight : 0
    this.root.style.setProperty('--formation-nav-top', `${top}px`)
  }

  bindMobileNav() {
    if (!this.toggle || !this.mobile) return

    this.toggle.addEventListener('click', () => {
      const open = this.mobile.classList.toggle('is-open')
      this.toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    })

    this.mobile.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        this.mobile.classList.remove('is-open')
        this.toggle.setAttribute('aria-expanded', 'false')
      })
    })
  }

  bindActiveSection() {
    if (!this.sections.length || !('IntersectionObserver' in window)) return

    const setActive = (id) => {
      const href = `#${id}`
      this.deskLinks.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === href))
      this.mobLinks.forEach((a) => a.classList.toggle('is-active', a.getAttribute('href') === href))
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id)
        })
      },
      { rootMargin: '-120px 0px -55% 0px', threshold: 0 }
    )

    this.sections.forEach((section) => observer.observe(section))
  }

  bindApplyModal() {
    if (!this.applyModal) return

    this.root.querySelectorAll('[data-formation-apply-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault()
        this.openApplyModal()
      })
    })

    this.applyModal.querySelectorAll('[data-formation-apply-close]').forEach((el) => {
      el.addEventListener('click', () => this.closeApplyModal())
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.applyModal.hidden) {
        this.closeApplyModal()
      }
    })
  }

  openApplyModal() {
    if (!this.applyModal) return
    this.applyModal.hidden = false
    document.body.classList.add('formation-apply-modal-open')
    this.applyModal.querySelector('[data-formation-apply-close]')?.focus()
  }

  closeApplyModal() {
    if (!this.applyModal || this.applyModal.hidden) return
    this.applyModal.hidden = true
    document.body.classList.remove('formation-apply-modal-open')
  }

  bindNoticeModal() {
    if (!this.noticeModal) return

    const key = this.noticeModal.dataset.noticeKey || ''

    this.noticeModal.querySelectorAll('[data-formation-notice-close]').forEach((el) => {
      el.addEventListener('click', () => this.closeNoticeModal(false))
    })

    this.noticeModal.querySelector('[data-formation-notice-dismiss]')?.addEventListener('click', () => {
      this.closeNoticeModal(true)
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.noticeModal.hidden) {
        this.closeNoticeModal(false)
      }
    })

    if (key && window.sessionStorage.getItem(key)) {
      return
    }

    this.openNoticeModal()
  }

  openNoticeModal() {
    if (!this.noticeModal) return
    this.noticeModal.hidden = false
    document.body.classList.add('formation-apply-modal-open')
    this.noticeModal.querySelector('[data-formation-notice-close]')?.focus()
  }

  closeNoticeModal(remember) {
    if (!this.noticeModal || this.noticeModal.hidden) return
    this.noticeModal.hidden = true
    document.body.classList.remove('formation-apply-modal-open')

    const key = this.noticeModal.dataset.noticeKey || ''
    if (!remember || !key) return

    try {
      window.sessionStorage.setItem(key, '1')
    } catch (error) {
      // sessionStorage peut être bloqué
    }
  }
}
